import { AvanoButtonBarButtonDetails, AvanoButtonBarGroup } from "../avano-button-bar.common";

export class AvanoButtonBarButtonUtils {
  static LABEL_WIDTH_IN_CHARS_MAX = 10;

  static splitLabelEquallish(fullLabel: string): string[] {
    if (fullLabel.length <= AvanoButtonBarButtonUtils.LABEL_WIDTH_IN_CHARS_MAX) {
      return [fullLabel];
    } else {
      let middle = Math.floor(fullLabel.length / 2);
      const before = fullLabel.lastIndexOf(' ', middle);
      const after = fullLabel.indexOf(' ', middle + 1);

      if (before === -1 || (after !== -1 && middle - before >= after - middle)) {
        middle = after;
      } else {
        middle = before;
      }

      const s1 = fullLabel.substr(0, middle);
      const s2 = fullLabel.substr(middle + 1);
      return [s1, s2];
    }
  }

  static buildEmptyErrorButton(group: AvanoButtonBarGroup = AvanoButtonBarGroup.PRIMARY): AvanoButtonBarButtonDetails {
    return  {
      icon: null,
      label: null,
      errorDetails: [],
      group: group
    };
  }
}
